import { useState, useEffect, useRef, useMemo } from 'react';
import PropTypes from 'prop-types';
import Slider from 'react-slick';
import axios from 'axios';
import { isMobile } from 'react-device-detect';
// @mui
import { useTheme, styled } from '@mui/material/styles';
import { Box, Card, CardActionArea, Grid, Stack, Typography } from '@mui/material';
// components
import { useSnackbar } from 'notistack';
import { useNavigate } from 'react-router-dom';

import { CarouselDots } from '../../components/carousel';
import Image from '../../components/Image';
import { useDispatch, useSelector } from '../../redux/store';
import useResponsive from '../../hooks/useResponsive';
import useAuth from '../../hooks/useAuth';
import { openLoginSignup } from '../../redux/slices/authPages';
import conObj from '../../utils/connection-assistant';
import { getOperatingSystem } from '../../utils/formatObject';
import { claimPromotionBanner, getUserMemberBalance } from '../../redux/slices/lookup';
import useLocales from '../../hooks/useLocales';
import { openConfirm } from '../../redux/slices/confirm';
import { LoadingPageHTML } from './Const';

// ----------------------------------------------------------------------

const carouselItems = [
  {
    title: 'Sports',
    img: require(`../../assets/home/hot_games/hg-sports.png`),
    slug: 'sports',
  },
  {
    title: 'Casino',
    img: require(`../../assets/home/hot_games/hg-casino.png`),
    slug: 'live-casino',
  },
  {
    title: 'Slots',
    img: require(`../../assets/home/hot_games/hg-slots.png`),
    slug: 'slots',
  },
  {
    title: 'Fishing',
    img: require(`../../assets/home/hot_games/hg-fishing.png`),
    slug: 'fishing',
  },
  // {
  //   title: 'Cards',
  //   img: require(`../../assets/home/hot_games/hg-cards.png`),
  //   slug: 'card-game',
  // },
];

// ----------------------------------------------------------------------

const FooterDivider = styled(Box)(({ theme, isLeft }) => ({
  height: '3px',
  background: `linear-gradient(${isLeft ? '90deg' : '270deg'}, #d9e3f0, #bdcfe8)`,
  width: '100%',
}));

const FooterTextLabel = styled(Typography)(({ theme }) => ({
  fontSize: '7vw',
  textTransform: 'uppercase',
  fontWeight: 900,
  background: 'linear-gradient(90deg, #007bb0, #3bbac5)',
  WebkitTextFillColor: 'transparent',
  color: 'transparent',
  backgroundClip: 'text',
  WebkitBackgroundClip: 'text',
  whiteSpace: 'nowrap',
  textAlign: 'center',
}));

// ----------------------------------------------------------------------

HotGamesCarousel.propTypes = {
  list: PropTypes.array,
};

export default function HotGamesCarousel({ ...other }) {
  const theme = useTheme();

  const { translate, currentLang } = useLocales();

  // const { siteSettings } = useSelector((x) => x.lookup);

  const { enqueueSnackbar } = useSnackbar();

  const isSm = useResponsive('down', 'sm');

  const carouselRef = useRef(null);

  const [currentIndex, setCurrentIndex] = useState(0);

  const [gamesByCategory, setGamesByCategory] = useState([]);

  // useEffect(() => {
  //   getPopularGamesByCategory();
  // }, []);

  // const getPopularGamesByCategory = (_category) => {
  //   const allCategory = carouselItems.map((item) =>
  //     conObj.post(`/games/items/${item?.slug}.json?sort=popularity&limit=4&page=1`)
  //   );

  //   axios.all(allCategory).then((res) => {
  //     const _gamesByCategory = [];
  //     if (res[0].status === 200) {
  //       _gamesByCategory.push({
  //         slug: 'sports',
  //         games: res[0].data?.data?.data,
  //       });
  //     }

  //     if (res[1].status === 200) {
  //       _gamesByCategory.push({
  //         slug: 'live-casino',
  //         games: res[1].data?.data?.data,
  //       });
  //     }

  //     if (res[2].status === 200) {
  //       _gamesByCategory.push({
  //         slug: 'slots',
  //         games: res[2].data?.data?.data,
  //       });
  //     }

  //     if (res[3].status === 200) {
  //       _gamesByCategory.push({
  //         slug: 'fishing',
  //         games: res[3].data?.data?.data,
  //       });
  //     }

  //     if (res[4].status === 200) {
  //       _gamesByCategory.push({
  //         slug: 'card-game',
  //         games: res[4].data?.data?.data,
  //       });
  //     }

  //     setGamesByCategory(_gamesByCategory);
  //   });
  // };

  // const handleLaunchGame = (code, isMaintenanceMode) => {
  //   if (isMaintenanceMode) return;

  //   const newTab = window.open();

  //   newTab.document.write(LoadingPageHTML);

  //   conObj
  //     .post(`games/launch/${code}.json`, {
  //       system_os: getOperatingSystem(),
  //       is_mobile: isMobile ? 1 : 0,
  //       return_url: window.location.href,
  //     })
  //     .then((res) => {
  //       if (res.status === 200) {
  //         const { status } = res.data.data;
  //         if (status === 1) {
  //           newTab.location.href = res.data?.data?.data?.url;
  //           // setIsLoading(false);
  //         }
  //       }
  //     })
  //     .catch((err) => {
  //       const snackbarOptions = { variant: 'error', autoHideDuration: 5000 };
  //       enqueueSnackbar(err.message, snackbarOptions);
  //       console.log(`Server Error: ${err.message}`);
  //       // setIsLoading(false);
  //       newTab.close();
  //     });
  // };

  const settings = {
    speed: 800,
    dots: true,
    arrows: false,
    autoplay: true,
    fade: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    rtl: Boolean(theme.direction === 'rtl'),
    beforeChange: (current, next) => setCurrentIndex(next),
    ...CarouselDots({
      zIndex: 1,
      bottom: -20,
      left: 0,
      right: 0,
      position: 'absolute',
    }),
  };

  return (
    <Box sx={{ mt: '.5rem', mb: '1.5rem' }}>
      <Stack direction={'row'} sx={{ alignItems: 'center' }}>
        <FooterDivider isLeft={true} />
        <Image
          src={require('../../assets/home/divider.png')}
          sx={{ width: '.6rem', minWidth: '.6rem', height: 'auto', display: 'flex', mx: '.05rem' }}
        />
        <FooterTextLabel sx={{ fontSize: {xs: currentLang?.value === 'id' ? '5vw' : '7vw', lg: currentLang?.value === 'id' ? '30px' : '35px'} }}>
          {translate('games')}
        </FooterTextLabel>
        <Image
          src={require('../../assets/home/divider.png')}
          sx={{
            width: '.6rem',
            minWidth: '.6rem',
            height: 'auto',
            display: 'flex',
            mx: '.05rem',
            transform: 'rotate(180deg)',
          }}
        />
        <FooterDivider isLeft={false} />
      </Stack>
      <Box sx={{maxWidth: 700, mx: 'auto'}}>
        <Slider ref={carouselRef} {...settings}>
          {carouselItems.map((data, index) => (
            <CarouselItem
              key={data?.id}
              item={data}
              isActive={index === currentIndex}
              // gamesByCategory={gamesByCategory}
              // handleLaunchGame={handleLaunchGame}
            />
          ))}
        </Slider>
      </Box>
    </Box>

    // <Card
    //   sx={{
    //     background: 'none',
    //     '& .slick-active': { zIndex: 999 },
    //     my: { sm: 2, xs: 1 },

    //     p: { xs: '0 .32rem' },
    //     boxShadow: 'none',
    //   }}
    //   {...other}
    // >

    // </Card>
  );
}

// ----------------------------------------------------------------------

CarouselItem.propTypes = {
  isActive: PropTypes.bool,
  //   item: PropTypes.shape({
  //     title: PropTypes.string.isRequired,
  //     // img: PropTypes.,
  //   }),
};

function CarouselItem({
  item,
  isActive,
  //  , gamesByCategory, handleLaunchGame
}) {
  // const navigate = useNavigate();

  // const isAuthenticated = localStorage.getItem('accessToken');

  const { translate, currentLang } = useLocales();

  //   const isClickable = useMemo(() => data?.is_manual_claimable || data?.url, [data?.is_manual_claimable, data?.url]);

  //   const isShowClaimedOverlay = useMemo(
  //     () => data?.is_manual_claimable && !data?.is_claimable_now && !data?.url,
  //     [data?.is_claimable_now, data?.is_manual_claimable, data?.url]
  //   );

  //   const handleClick = () => {
  //     if (isActive) {
  //       if (data?.url) {
  //         window.open(data.url, '_blank');
  //       } else if (data?.is_manual_claimable) {
  //         if (!isAuthenticated) navigate('/auth/navigate');
  //         if (data?.is_claimable_now && isAuthenticated) {
  //           dispatch(
  //             openConfirm({
  //               title: `${translate('claim_bonus')}?`,
  //               subTitle: data?.title || '',
  //               onConfirm: handleClaimBonus,
  //             })
  //           );
  //         }
  //       } else {
  //         // Do nothing
  //       }
  //     }
  //   };

  return (
    <Box
      sx={{
        // height: { md: '12rem', sm: '60vw', xs: '60vw' },
        position: 'relative',
        m: '.3rem',
        // background: 'aliceblue',
        // boxShadow: '0px 0px 4px .5px rgb(0, 0, 0, .3)',
        // border: '.12rem solid #fff',
        // borderRadius: '.4rem',
      }}
    >
      <Typography
        sx={{
          position: 'absolute',
          fontSize: currentLang?.value === 'id' ? '7vw' : '1rem',
          fontWeight: 900,
          color: '#fff',
          textShadow: '0px 4px 2px #000',
          zIndex: 1,
          top: currentLang?.value === 'id' ? '.2rem' : 'unset',
          right: '.2rem',
          width: 'auto',
          textAlign: 'center',
        }}
      >
        {translate(item?.title)}
      </Typography>
      {/* <Box
        sx={{ position: 'relative', width: '100%', height: 0, pt: 'calc(339 / 340 * 100%)' }}
      > */}
      <Image
        ratio={'339 * 340'}
        alt={'Carousel'}
        src={item?.img}
        sx={{
          boxShadow: '0px 0px 4px .5px rgb(0, 0, 0, .3)',
          borderRadius: '0.2rem',
          //   width: 'max-content',
          width: '100%',
          // height: '100%',
          //   ml: '-.3rem',
          img: {
            objectFit: 'contain',
          },
        }}
      />
      {/* </Box> */}
      {/* <Grid container sx={{ height: '100%' }}>
        <Grid item xs={5.5}>
          <Image
            alt={'Carousel'}
            src={item?.img}
            sx={{
              borderRadius: '0.2rem',
              //   width: 'max-content',
              width: 'auto',
              height: '100%',
              //   ml: '-.3rem',
              img: {
                objectFit: 'contain',
              },
            }}
          />
        </Grid>
        <Grid item xs={6.5} sx={{ zIndex: 1 }}>
          <Stack direction="column" sx={{ mt: '.4rem' }}>
            <FooterTextLabel sx={{ lineHeight: 1, fontSize: currentLang?.value === 'id' ? '3.5vw' : '7vw' }}>
              {translate(item?.title)}
            </FooterTextLabel>
            <Box sx={{ p: '.2rem' }}>
              <Grid container spacing={'.2rem'} sx={{ mt: '-.1rem' }}>
                {gamesByCategory.length > 0 &&
                  gamesByCategory
                    .find((f) => f?.slug === item?.slug)
                    ?.games?.map((item, index) => (
                      <Grid
                        item
                        xs={6}
                        key={index}
                        sx={{ p: '.1rem' }}
                        onClick={() =>
                          isAuthenticated
                            ? handleLaunchGame(item?.code, item?.is_maintenance_mode)
                            : navigate('/auth/login')
                        }
                      >
                        <Image
                          src={item?.photo_url}
                          sx={{
                            height: 'auto',
                            width: '100%',
                            borderRadius: '.05rem',
                            boxShadow: '0px 0px 4px 1px rgb(0, 0, 0, .2)',
                            filter: `grayscale(${item?.is_maintenance_mode ? 1 : 0})`,
                          }}
                        />
                      </Grid>
                    ))}
              </Grid>
            </Box>
          </Stack>
        </Grid>
      </Grid> */}
    </Box>
  );
}
